<template>
  <div>
    <programs-single-graduates-admin v-if="$userIsAdmin"/>
    <programs-single-graduates-coordinator v-if="$userIsCoordinator"/>
  </div>
</template>
<script>
import ProgramsSingleGraduatesAdmin from './ProgramsSingleGraduatesAdmin'
import ProgramsSingleGraduatesCoordinator from './ProgramsSingleGraduatesCoordinator'

export default {
  components: {
    ProgramsSingleGraduatesAdmin,
    ProgramsSingleGraduatesCoordinator
  }
}
</script>
